import React from 'react'
import WebSal from '../assets/websalNegro.png'

export const Logo = () => {
  return (
    <div >

       <img src={ WebSal} width="300" height="300" />

    </div>



   
  )
}
